export class ApiResponseError extends Error {
    readonly errors: string[];

    constructor(message: string, errors: string[] = []) {
        super(message);
        this.name = "ApiResponseError";
        this.errors = errors;

        Object.setPrototypeOf(this, ApiResponseError.prototype);
    }
}